import AlertDialogReducer from './AlertDialogReducer';
import { combineReducers } from 'redux';
import DataGraphAlertReducer from './DataGraphAlertReducer';
const AlertReducer = combineReducers({
    DataGraphAlertReducer,
    AlertDialogReducer
});
  
  
export default AlertReducer;